const API_KEY = 'b0ec7e80c19b41ae8e7200423200511';
export default API_KEY;
